<template>
	<div>
        <v-layout row wrap justify-center align-center>
            <v-flex md12 lg12 xs12 sm12>
		        <apexchart dark type=line height=400 :options="chartOptions" :series="series"></apexchart>
            </v-flex>
        </v-layout>
	</div>
</template>

<script>
import apexchart from 'vue-apexcharts'

export default {
    components: {
        apexchart
    },
    props: {
        values: Object,
        valueName: {
            type: String,
            default: ''
        },
        xName: {
            type: String,
            default: ''
        },
        yName: {
            type: String,
            default: ''
        },
        finalizadorValor: {
            type: String,
            default: ''
        },
    },
    methods: {

    },
    data: function() {
        var context = this
        return {
			series: [
                {
                    name: context.valueName,
                    type: 'line',
                    data: this.values.valor != undefined ? this.values.valor : [0]
                }
			],
			chartOptions: {
                colors: ['#87e2d1'],
                dataLabels: {
                    enabled: false,
                },
                labels: this.values.nrDias,
                stroke: {
                    curve: 'straight'
                },
                xaxis: {
                    type: 'category',
                    title: {
                        text: context.xName,
                        style: {
                            color: 'gray'
                        }
                    },
                    labels: {
                        style: {
                            colors: 'gray'
                        },
                        formatter: function (val) {
                            if (context.xName == 'Semana')
                            {
                                return val
                            }
                            else
                            {
                                return  val + ' dias'
                            }
                        },
                    },
                    tooltip: {
                        enabled: false
                    }
                },
				yaxis: {
                    title: {
                        text: context.yName,
                        style: {
                            color: 'gray'
                        }
                    },
                    labels: {
                        style: {
                            color: 'gray'
                        },
                        formatter: function (val) {
                            return val.toFixed(3)
                        }
                    }
                },
                tooltip: {
                    style: {
                        fontSize: '14px',
                        fontFamily: undefined
                    },
                    y: {
                        formatter: function (val) {
                            return val.toFixed(3) + context.finalizadorValor
                        }
                    }
                },
                legend: {
                    position: 'top',
                    horizontalAlign: 'center',
                    fontSize: '14px',
                    labels: {
                        colors: 'gray',
                        useSeriesColors: false
                    },
                },
            }
        }
    }
}

</script>

<style>
    .apexcharts-menu.open {
        color: black;
    }
    .apexcharts-tooltip {
        background: #f3f3f3;
        color: black;
    }
</style>
